// Angular Import
import { ChangeDetectorRef, Component, Input, input } from '@angular/core';

// project import
import { NavigationItem } from '../../types/navigation';
import { SharedModule } from 'src/app/@core/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModule } from 'src/app/@core/shared/base.module';
import { BreadcrumbService, titleType } from '../../services/breadcrumb.service';
import { getMenu } from 'src/app/components/data/menu';



@Component({
  selector: 'app-breadcrumb',
  imports: [BaseModule, SharedModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {

  // public props
  @Input() type: string;
  readonly dashboard = input(true);

  navigations: NavigationItem[];
  navigationList: titleType[] = [];
  visibility: boolean;

  // constructor
  constructor(private breadcrumbservice: BreadcrumbService, private cdr: ChangeDetectorRef) {
    this.navigations = getMenu();
    this.type = 'theme2';


    this.breadcrumbservice.breadcrumb.subscribe((breadcrumbs: titleType[]) => {
      this.navigationList = breadcrumbs;

    });

    this.breadcrumbservice.visibility.subscribe((visibility: boolean) => {
      this.visibility = visibility;
    });
  }


}
